import { createContext, useContext } from 'react';

/**
 * One indoor positioning session, shared by the map and the directions form.
 *
 * `useIndoorPositioning` owns real state - a native subscription, a detection timer and the
 * START/STOP messages - so calling it from two components would start two independent sessions
 * that each believe they are the only one, and a `start()` in one would leave the other's spinner
 * running forever. MapLayout runs the hook once and publishes the result here; everything below
 * it (the map controls, DirectionsPage) reads that same session.
 */

const IndoorPositioningContext = createContext(null);

// Inert session for anything rendered outside the provider (StreetViewPage has no layout), so it
// renders normally with positioning simply unavailable rather than throwing.
const INERT_SESSION = {
	available: false,
	position: null,
	heading: null,
	status: null,
	loading: false,
	error: null,
	active: false,
	start: () => {},
	stop: () => {},
	clearError: () => {}
};

export const IndoorPositioningProvider = ({ value, children }) => (
	<IndoorPositioningContext.Provider value={value}>
		{children}
	</IndoorPositioningContext.Provider>
);

export const useSharedIndoorPositioning = () => useContext(IndoorPositioningContext) || INERT_SESSION;

export default IndoorPositioningContext;
